import {ApiHelper, axiosInstance } from '../utils/ApiHelper'
import moment from 'moment'
import axios from 'axios'
import { SubmissionError, change } from 'redux-form'
import AnalyticsHelper from '../utils/AnalyticsHelper'
import CloudEvent from '../utils/CloudEvent'
import { getTxnById } from './reducer'
import { message } from 'antd'
import { isMatchingFilters, isNotMatchingFilters, isSameDate } from '../models'



export function loadTransaction(transactionId) {
  // in Update, initially polyline from transaction.locations,
  // markers from, to

  return (dispatch, getState) => {

      const transaction = getState().models.transactions.filter(transaction=>transaction.token_id==transactionId)[0]
      dispatch({type: 'LOAD_TRANSACTION', transaction})

  }
}

export function onSelectPurpose(purpose) {

  return (dispatch, getState) => {

    if (getState().models.user.income_sources.includes(purpose)) {
      dispatch(change('transaction', 'income_source', purpose))
      dispatch(change('transaction', 'purpose', 'Work'))
    } else {
      dispatch(change('transaction', 'purpose', purpose))
      dispatch(change('transaction', 'income_source', null))
    }
  }
}

export function getTransaction(transactionId) {

  return (dispatch, getState) => {
    dispatch({type: 'GET_TRANSACTION_REQUEST'})

    const transaction = getState().models.transactions.find((transaction)=>transaction.token_id==transactionId)
    if (transaction) {
      // wrap in a promise that is expected to be returned
      const txnFromState = new Promise((resolve, reject) => {
        dispatch({type: 'GET_TRANSACTION_SUCCESS', transaction })
        resolve(transaction)
      });
      return txnFromState
    }

    // otherwise, if not found in redux state

    return ApiHelper.getTransaction(transactionId)
    .then( json => {
      const transaction = json.data
      dispatch({type: 'GET_TRANSACTION_SUCCESS', transaction })
      return transaction
    })

  }
}


export function getTransactions() {
  return (dispatch, getState) => {
    const { filters } = getState().transactions

    dispatch({type:'GET_TRANSACTIONS_REQUEST'})

    return ApiHelper.getTransactions(filters)
    .then( json => {
      dispatch({type: 'GET_TRANSACTIONS_SUCCESS', user: {transactions: json.data} })
      dispatch(toggleManyTxns())
    })


  }
}

export function mergeTransactions(data){

  return (dispatch, getState) => {
    const prevState = getState()
    dispatch({type:'MERGE_TRANSACTIONS_REQUEST'})

    return ApiHelper.mergeTransactions({merge_transactions_token_ids: data}).then(
      (json)=>{
        dispatch({type:'MERGE_TRANSACTIONS_SUCCESS', merged_transaction: json.data, token_ids: data})
        dispatch(decrementUnclassfiedCount(prevState, data))

      },
      (error)=>{
        dispatch({type:'MERGE_TRANSACTIONS_ERROR'})
      }
    )
  }
}

export function deleteTransaction(tripId) {
  return dispatch => {
    AnalyticsHelper.trackEvent(CloudEvent.TransactionDeleted)

    return dispatch( deleteTransactions({token_ids:[tripId]}) )
  }
}

export function deleteTransactions(data){

  return (dispatch, getState) => {
    const prevState = getState()
    dispatch({type:'DELETE_TRANSACTIONS_REQUEST', data: data})

    return ApiHelper.deleteTransactions({filter_params: data}).then(
      (json)=>{
        dispatch(getTotals())
        AnalyticsHelper.trackEvent(CloudEvent.BatchDeleted)

        dispatch({type:'DELETE_TRANSACTIONS_SUCCESS', token_ids: data.token_ids})
        dispatch(decrementUnclassfiedCount(prevState, data.token_ids))
        dispatch(untoggleAllTransactions())

      },
      (error)=>{
        dispatch({type:'DELETE_TRANSACTIONS_ERROR'})
      }
    )
  }
}

export function decrementUnclassfiedCount(prevState, ids) {
  return (dispatch) => {
    const count = ids.filter(id=>
      getTxnById(prevState, id)
        .purpose==null
    ).length

    if (count>0) dispatch({type:'DECREMENT_UNCLASSIFIED_TXN_COUNT', count})

  }
}

export function updateTransaction(data) {
  return (dispatch, getState) => {
    // get the trip before it's changed so we can DECREMENT_TRIP_COUNT
    const { purpose } = data
    const prevState = getState()
    const { filters } = getState().transactions

    // If an income source was selected as purpose, then reshape data
    if (data.purpose && getState().models.user.income_sources.includes(data.purpose)) {
      data['income_source'] = data.purpose
      data['purpose'] = "Work"
    } else if (data.purpose && !data.income_source) {
      data['income_source'] = ''// null
    }

    dispatch({type:'UPDATE_TRANSACTION_REQUEST', transaction: data})

    return ApiHelper.updateTransaction(data).then(
      (json)=> {
        const transaction = json.data

        dispatch(getTotals())

        if (transaction.amount<0) {
          console.log('expense because negative?')
          AnalyticsHelper.trackEvent(CloudEvent.ExpenseUpdated)
        } else {
          AnalyticsHelper.trackEvent(CloudEvent.RevenueUpdated)
        }

        dispatch({type:'UPDATE_TRANSACTION_SUCCESS', transaction})

        dispatch(decrementUnclassfiedCount(prevState, [transaction.token_id]))
        message.success(`Transaction updated`)

        if (isNotMatchingFilters(filters, transaction)) dispatch({type: 'REMOVE_TXN', transaction})

        return transaction
      },
      (err) => {
        dispatch({type:'UPDATE_TRANSACTION_ERROR'})
      }
    )
  }
}

export const getUpdateParams = (state, purpose) => {
  const { income_sources } = state.models.user

  if (purpose && income_sources.includes(purpose)) {
    return {
      income_source: purpose,
      purpose: "Work"
    }
  } else {

    return {
      income_source: null,
      purpose
    }
  }

}

const withoutNulls = (obj) => {
  const newObj = {...obj}
  Object.keys(newObj).forEach((key) => (newObj[key] == null) && delete newObj[key]);
  return newObj
}


export function batchClassify(purposeOption) {
  return (dispatch, getState) => {
    const { income_sources } = getState().models.user
    const prevState = getState()


    const { filter_params, filters, hasSelectedAll, totalResultsCount } = getState().transactions

    const data = {
      filter_params: hasSelectedAll
        ? withoutNulls(filters) // NOTE we are removing null values
        : filter_params, // always array of token_ids
      update_params: getUpdateParams(getState(), purposeOption) // keep null values
    }

    dispatch({type:'UPDATE_TRANSACTION_BATCH_REQUEST', data })

    return ApiHelper.updateTransactions(data).then(
      ({ data: transactions })=> {
        AnalyticsHelper.trackEvent(CloudEvent.BatchClassify)
        dispatch({type:'UPDATE_TRANSACTION_BATCH_SUCCESS', transactions })
        dispatch(getTotals())

        dispatch(untoggleAllTransactions())

        const count = hasSelectedAll?totalResultsCount:filter_params.token_ids.length

        dispatch({
          type: 'SHOW_MODAL',
          modalType: 'CLASSIFY_FILTERED_MODAL',
          modalProps:{
            buttonText: "Got it",
            title: `${count} Transactions Updated`,
            message: `${count} transactions have been successfully classified as ${purposeOption}`,
          }
        })

        if (!hasSelectedAll) {
          dispatch(decrementUnclassfiedCount(prevState, filter_params.token_ids))
        }

        if (hasSelectedAll) {
          if (data.filter_params.uncategorized) dispatch({type:'DECREMENT_UNCLASSIFIED_TXN_COUNT', count: totalResultsCount})
        }

        transactions.forEach(transaction=> isNotMatchingFilters(filters, transaction) && dispatch({type: 'REMOVE_TXN', transaction }) )

      },
      (err)=> dispatch({type:'UPDATE_TRANSACTION_BATCH_ERROR'})
    )
  }
}



export function untoggleAllTransactions() {
  return (dispatch) => {
   dispatch({type: 'HIDE_CHECKBOXES'})
   dispatch({type: 'UNTOGGLE_ALL_TRANSACTIONS'})
   dispatch({type: 'UNSELECT_ALL_FILTERED_TXNS'})
 }
}



export function toggleTransaction(token_id) {
  // TODO replace with https://github.com/rt2zz/redux-persist
  localStorage.setItem('wasTxnChecked', true)
  return (dispatch, getState) => {
    dispatch({type: 'TOGGLE_TRANSACTION', token_id})
    dispatch({type: 'SHOW_CHECKBOXES'})

    const { filter_params: {token_ids}, hasSelectedAll } = getState().transactions
    const { transactions } = getState().models
    const areAllToggled = token_ids.length == transactions.length
    if (hasSelectedAll && !areAllToggled) dispatch(untoggleAllTransactions())
  }
}


export function toggleManyTxns() {
  return (dispatch, getState) => {
    const { hasSelectedAll } = getState().transactions
    const { transactions } = getState().models

    if (hasSelectedAll) {
      const tokenIds = transactions.map(txn=> txn.token_id)
      dispatch({type: 'UNTOGGLE_ALL_TXNS'})
      dispatch({type: 'SHOW_CHECKBOXES'})

      dispatch({type: 'TOGGLE_MANY_TXNS', tokenIds})
    }


  }
}

export function hideCheckboxes() {
  return (dispatch) => {
    dispatch({type: 'HIDE_CHECKBOXES'})
  }
}


export function showCheckboxes() {
  return (dispatch) => {
    dispatch({type: 'SHOW_CHECKBOXES'})
  }
}

export function onOpenChange() {
  return (dispatch) => {

    dispatch({type: 'TOGGLE_RANGEPICKER'})

  }
}

export function clearFilters() {
  return (dispatch) => {
    dispatch({type: 'CLEAR_ALL_FILTERS'})
    dispatch({type: 'UNTOGGLE_ALL_TXNS'})
    dispatch({type: 'HIDE_CHECKBOXES'})

    dispatch({type: 'UNSELECT_ALL_FILTERED_TXNS'})
    dispatch(getTransactions())
    dispatch(getTotals())

  }
}

export function updateNote(prevNotes, notes, token_id) {
  if (notes.trim().length>0 && prevNotes != notes) alert(notes)
  return (dispatch) => {

  }
}


export function updateRange(value) {
  return (dispatch) => {
    AnalyticsHelper.trackEvent(CloudEvent.FilterDates)
    dispatch({type: 'CLOSE_FILTER_POPOVER'})

    dispatch({type: 'APPLY_DATE_FILTER', dateRange: value})
    dispatch(getTransactions())
    dispatch(getTotals())
  }
}

export function selectFilter(filter) {
  return (dispatch, getState) => {
    AnalyticsHelper.trackEvent(CloudEvent.FilterBusinessLine)
    const { income_sources } = getState().models.user
    dispatch({type:'SELECT_FILTER_PURPOSE', filter, income_sources})
    dispatch(getTransactions())
    dispatch(getTotals())
  }
}

export function selectCategoryFilter(filter) {
  return (dispatch, getState) => {
    AnalyticsHelper.trackEvent(CloudEvent.FilterCategory)
    dispatch({type:'SELECT_FILTER_CATEGORY', filter})
    dispatch(getTransactions())
    dispatch(getTotals())
  }
}

export function selectFilterTransactionType(filter) {
  return (dispatch, getState) => {
    AnalyticsHelper.trackEvent(CloudEvent.FilteredTransactions)
    dispatch({type:'SELECT_FILTER_TRANSACTION_TYPE', filter})
    dispatch(getTransactions())
    dispatch(getTotals())
  }
}
export function selectFilterInstitutionAccountName(filter) {
  return (dispatch, getState) => {
    AnalyticsHelper.trackEvent(CloudEvent.FilterBankAccount)
    dispatch({type:'SELECT_FILTER_INS_ACCOUNT_ID', filter})
    dispatch(getTransactions())
    dispatch(getTotals())
  }
}

export function loadMore() {
  return (dispatch, getState) => {
    const { filters } = getState().transactions

    const starting_after = getState().models.transactions[getState().models.transactions.length - 1].token_id

    dispatch({type:'GET_MORE_TRANSACTIONS_REQUEST'})

    return ApiHelper.getTransactions({starting_after, ...filters})
      .then( json => {
        if (json.data.length==0) return dispatch({type: 'NO_MORE_TRANSACTIONS' })
        // NOTE preload to check ahead of time instead of having user click
        // or ... check if json.data.length<10 ...

        if (json.data.length<10) {
          dispatch({type: 'GET_MORE_TRANSACTIONS_SUCCESS', user: {transactions: json.data} })
          dispatch({type: 'NO_MORE_TRANSACTIONS' })
          return
        }
        // else
        dispatch({type: 'GET_MORE_TRANSACTIONS_SUCCESS', user: {transactions: json.data} })
        dispatch(toggleManyTxns())
      } )

  }
}

export function createTransaction(data) {
  // handle .date to .date_formatted and vice versa
  // handle .from or .to if value is place name (.start_place_token, .locations)
  return dispatch => {
    dispatch({type: 'CREATE_TRANSACTION_REQUEST', transaction: data})
    // return console.log({transaction: data})
    return ApiHelper.createTransaction(data)
      .then(json => {
        const transaction = json.data
        dispatch(getTotals())

        if (transaction.amount<0) {
          console.log('expense because negative?')
          AnalyticsHelper.trackEvent(CloudEvent.ExpenseCreated)
        } else {
          AnalyticsHelper.trackEvent(CloudEvent.RevenueCreated)

        }

        dispatch({
            type:'NEW_TRANSACTION_ADDED',
            transaction,
            receivedAt: Date.now(),
         })
        //  dispatch(push(`/transactions`))
         return transaction
     }
   )
  }
}


export function getTotals() {
  return (dispatch, getState) => {
    const { filters } = getState().transactions
    dispatch({type: 'GET_TOTALS_REQUEST'})
    return ApiHelper.getTotals(filters)
      .then( json => dispatch({type: 'GET_TOTALS_SUCCESS', user: {totals: json.data} }) )

  }
}



export function selectAll() {
  return (dispatch, getState) => {
    // select all checkboxes visible

    dispatch({type:'SELECT_ALL_FILTERED_TXNS'})
    dispatch(toggleManyTxns())


  }
}



// WEBPACK FOOTER //
// ./src/transactions/actions.js